import { i18n } from '../../../i18n';
let mounted = false;

export async function ensureFlyoverMounted(): Promise<boolean> {
  if (mounted || typeof (window as any).showMapModalForCoordinates === 'function') {
    return true;
  }

  let target = document.querySelector('#flyover_preview');
  if (!target) {
    target = document.createElement('div');
    target.id = 'flyover_preview';
    document.body.appendChild(target);
  }

  try {
    const { createApp } = await import('vue');
    const { default: FlyoverPreview } = await import('../../flyover_preview/FlyoverPreview.vue');
    const { default: flyoverStore } = await import('../../flyover_preview/store/store');

    const app = createApp(FlyoverPreview);
    app.use(flyoverStore);
    app.use(i18n);
    app.mount(target);

    // Wait for Vue's mounted() hook to execute and set window globals
    await new Promise(resolve => setTimeout(resolve, 300));

    mounted = typeof (window as any).showMapModalForCoordinates === 'function';
    if (!mounted) {
      console.error('[FlyoverMount] Component mounted but showMapModalForCoordinates not set on window');
    }
    return mounted;
  } catch (e) {
    console.error('[FlyoverMount] Failed to mount flyover preview:', e);
    return false;
  }
}
